module.exports = __webpack_public_path__ + "img/cdk_4.c3279256.png";